import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'workShiftsDays',
  standalone: false
})
export class WorkShiftsDaysPipe implements PipeTransform {
  transform(workShifts, isGRS): any {
    return Array.isArray(workShifts) && isGRS
      ? workShifts.slice(1)
      : workShifts;
  }
}
